import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { getAdjacentSteps, type PlanStep } from './getAdjacentSteps';
import styles from './DevelopmentPlan.module.scss';

type PlanStepNavigationProps<T extends PlanStep> = {
  steps: T[];
  activeId: T['id'];
  onNavigate: (id: T['id']) => void;
};

export const StepNavigation = <T extends PlanStep>({
  steps,
  activeId,
  onNavigate,
}: PlanStepNavigationProps<T>) => {
  const { previous, next } = getAdjacentSteps(steps, activeId);

  if (!previous && !next) {
    return null;
  }

  return (
    <nav
      className={`${styles.stepNav} ${
        previous ? '' : styles.stepNavOnlyNext
      }`.trim()}
      aria-label="Stegnavigasjon"
    >
      {previous ? (
        <button
          type="button"
          className={styles.stepNavPrev}
          onClick={() => onNavigate(previous.id)}
        >
          <ArrowBackIcon fontSize="small" aria-hidden />
          Forrige
        </button>
      ) : null}
      {next ? (
        <button
          type="button"
          className={styles.stepNavNext}
          onClick={() => onNavigate(next.id)}
        >
          Neste: {next.title}
          <ArrowForwardIcon fontSize="small" aria-hidden />
        </button>
      ) : null}
    </nav>
  );
};
